export default class BPAbholungKundeRequest {
  id: string
  kundeNachname: string
  kundeVorname: string
  kundeTelefon: string
  kundeEmail: string
}
